interface FiatEntry {
  date: string;
  base: string;
  rates: Record<string, number>;
}

export const useFiatStore = defineStore('FiatStore', () => {
  const fiats = ref<FiatEntry[] | null>(null)

  const setFiats = (data: FiatEntry[] | null) => {
    fiats.value = data
  }

  return {
    fiats,
    setFiats
  }
})
